<template>
  <div class="company-layout">
    <div class="inner">
      <div class="company-box">
        <div class="title">数千家企业机构正在使用赛码</div>
        <div class="font-14">
          已帮助超过<span
            style="font-size: 15px; font-weight: 400; color: #29bdb9"
            v-html="config.company"
          ></span
          >家客户 <span v-if="isMobile"><br /></span> 完成了<span
            style="font-size: 15px; font-weight: 400; color: #29bdb9"
            v-html="initTxt(config.intervieweeCount)"
          ></span
          >人次视频面试<br />
          合作客户使用赛码多轮一站式<span v-if="isMobile"><br /></span
          >面试系统，面试官叫号系统等<br />
          完美解决海量毕业生异地视频面试的难题
        </div>
        <div class="lists">
          <el-carousel indicator-position="outside" :height="carouselHeight">
            <el-carousel-item>
              <div class="list">
                <ul>
                  <li v-for="(item, index) in logos1" :key="index">
                    <div class="img"><img class="gray" :src="item.url" /></div>
                  </li>
                </ul>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="list">
                <ul>
                  <li v-for="(item, index) in logos2" :key="index">
                    <div class="img"><img class="gray" :src="item.url" /></div>
                  </li>
                </ul>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from "@/api.js";
export default {
  data() {
    return {
      logos1: [],
      logos2: [],
      config: {},
      isMobile: false,
      carouselHeight: '400px',
    }
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
    if (this.isMobile) {
      this.carouselHeight = '580px'
    } else {
      this.carouselHeight = '400px'
    }
    this.logos1 = new Array(12).fill(0).map((_, index) => ({
      url: `${CDN_URL}/images/inv-logo/` + (index + 1) + '.png',
    }))
    this.logos2 = new Array(12).fill(0).map((_, index) => ({
      url: `${CDN_URL}/images/inv-logo/` + (index + 13) + '.png',
    }))
    if (this.loadConfig.interviewStatic) {
      this.config = this.loadConfig.interviewStatic
    }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.interviewStatic) {
        this.config = newVal.interviewStatic
      }
    },
  },
  methods: {
    initTxt(num) {
      num = parseInt(num)
      var re = /(?=(?!\b)(\d{3})+$)/g
      return num.toString().replace(re, ',')
    },
  },
}
</script>

<style lang="scss" scoped>
.company-layout {
  display: grid;
  height: 100%;
  .inner {
    margin: auto;
    position: relative;
    top: -30px;
  }
}
.company-box {
  padding: 50px 0px 0px;
  text-align: center;
  width: 1200px;
  margin: 0px auto;
  font-weight: 300;
  .title {
    padding: 20px 0px;
    font-size: 36px;
  }

  .lists {
    .list {
      width: 100%;
      padding: 20px 100px;
      ul {
        width: 100%;
        li {
          width: 25%;
          display: inline-flex;
          margin-bottom: 10px;
          div.img {
            width: 90%;
            text-align: center;
            padding: 10px;
            border: 1px solid #dedede;
            box-shadow: 0px 2px 12px 6px rgba(0, 0, 0, 0.05);
            margin: 0px auto 20px;
            img {
              margin: 0px auto;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .company-box {
    width: 340px !important;
    padding-top: 60px;
    color: #333;
    font-weight: 320;
    .title {
      font-size: 24px;
    }
    .lists {
      padding: 20px 0 0 0;
      .list {
        padding: 0;
      }
    }
    .lists .list ul li {
      width: 50%;
      div.img img {
        height: 40px;
      }
    }
    .subtitle {
      font-size: 12px;
      padding: 5px;
      color: #666;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .company-box {
    width: 550px !important;
    padding-top: 60px;
    color: #333;
    font-weight: 320;
    .title {
      font-size: 24px;
    }
    .lists {
      padding: 20px 0 0 0;
      .list {
        padding: 0;
      }
    }
    .lists .list ul li {
      width: 50%;
      div.img img {
        height: 40px;
      }
    }
    .subtitle {
      font-size: 12px;
      padding: 5px;
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/company.vue